export const DEFAULT_GRADIENT =
  'radial-gradient(109.81% 107.82% at 100.1% 90.19%, #0F6CBD 33.63%, #2D87C3 70.31%, #8DDDD8 100%)'

export enum LANGUAGES {
  PL = 'pl'
}
